import React, { forwardRef, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import { uniqBy, isEmpty } from 'lodash';
import GenericMappingForm from '../GenericMappingForm';
import { Form } from 'antd';

const ThreatModelerMappingForm = forwardRef(function ThreatModelerMappingForm({disableProjectFields = false, ...props}, ref) {    
    const [form] = Form.useForm();
    const [mappedProjectList] = useState(() => {

        if (props.record) {
            const { projectId, projectName } = props.record;
            return {
            projects: projectId ? [{ id: projectId, name: projectName }] : [],
            }
        }
        return { projects: [] }
    })

    const [options,setOptions] = useState(mappedProjectList.projects);
        
    const setOptionsFromPagination = (option) => {
        setOptions(prev => uniqBy([...prev,...option], 'id'));
    }

    const fetchProjects = useCallback((params) => {
        const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId, ...params });
        promise.then((response) => {
            if(mappedProjectList['projects'].length > 0 && !isEmpty(response.projects)){
            response.projects = [...response.projects, ...mappedProjectList['projects']];
            }
            setOptionsFromPagination(response.projects)
        });
        return { promise, cancel };
    }, [props.toolName, mappedProjectList, props.loginConfigId]);

    const getExtraFieldsData = useCallback((config) => {
        const { projectId } = config;
        return {
        projectId,
        projectName: options.find(project => project.id === projectId)?.name,
        ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
        };
    }, [options]);

    const extraFields = useMemo(() => ([{
        name: 'projectId',
        colSpan: '12',
        type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
        label: 'Threat Model',
        disabled: disableProjectFields,
        required: true,
        props: {
          autoFocus: !disableProjectFields,
          api: fetchProjects,
        }
      }
    ]), [fetchProjects, disableProjectFields]);
  
    return (
      <GenericMappingForm
        form={form}
        ref={ref}
        getExtraFieldsData={getExtraFieldsData}
        extraFields={extraFields}
        {...props}
      />
    )
});

export default ThreatModelerMappingForm;